var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.as,_vm._g({tag:"component",staticClass:"button icon-only",class:{ floating: _vm.floating, dense: _vm.dense },attrs:{"type":_vm.buttonType,"aria-label":_vm.ariaLabel}},_vm.$listeners),[_vm._t("default",function(){return [_c('Icon',{attrs:{"name":_vm.name}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }